import { render, staticRenderFns } from "./property-table-card.vue?vue&type=template&id=61c7fa98&"
import script from "./property-table-card.vue?vue&type=script&lang=js&"
export * from "./property-table-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports